import { RootStateType } from '../../../../redux-store/reducers';
import { getCountries } from '../../../../redux-store/actions/link';
import { connect, useDispatch, useSelector } from 'react-redux';
import NomineeDetailsPurchase from './NomineeDetailsPurchase';
import FatcaDetailsPurchase from './FatcaDetailsPurchase';
import PersonalDetailsPurchase from './PersonalDetailsPurchase';
import { LoadDots } from '../../../../lib/Button';
import { useHistory } from 'react-router';
import { useState, useRef, useEffect, useCallback } from 'react';
import BankDetailsPurchase from './BankDetailsPurchase';
import en from '../../../../lang/en-us';
import { debounce, Button } from '@material-ui/core';
import { CommercialRootPath } from '../routeConfig';
import {
    CLEAR_SIP_OR_LUMPSUM,
    UPDATE_PURCHASE_INFO,
} from '../../../../redux-store/types/newPurchase';
import { NewPurchaseValidations, validateNomineeDetails } from '../ExploreMFs/Validations';
import { ErrorSectionTypes, ValidationErrorRes } from '../ExploreMFs/types';
const { dbCommercial } = en;

export type BoxDataType = {
    label: string;
    value: string;
    isEditable: boolean;
    apiKey: string;
    displayValue?: string;
    name: string;
    getHelperText?: (value: string) => string;
    errors?: any;
    upperCase?: boolean;
    dropDown?: boolean;
    dropDownValues?: Array<string>;
    datePicker?: boolean;
    helperObjectForValues?: any;
    isNumber?: boolean;
    maxLength?: Number;
    validate?: (value: any) => boolean;
};

function ProfileDetails(props: any) {
    const [countryData, setCountries] = useState<any>();
    const { purchaseDetails } = props;
    const [purchaseDetailsInfo, setPurchaseDetailsInfo] = useState<any>(purchaseDetails);
    const [errorSection, setErrorSecton] = useState<ValidationErrorRes | null>(null);
    const initData = useRef(purchaseDetails);
    const dispatch = useDispatch();
    const resetData = useCallback(() => {
        dispatch({
            type: UPDATE_PURCHASE_INFO,
            body: initData.current,
        });
    }, []);

    const [isProceed, setIsProceed] = useState<boolean>(false);
    const leftScrollRef = useRef<any>(null);
    const [activeIndex, setActiveIndex] = useState<number>(0);

    const _handleLeftPane = (index: number) => {
        leftScrollRef.current?.children[index]?.scrollIntoView({ behavior: 'smooth' });
        setActiveIndex(index);
    };

    const _handleRightScroll = debounce((leftRef: any = {}) => {
        if (!leftRef.current?.children?.length) return;
        const { offsetTop, children } = leftRef.current || {};
        for (let i = 0; i < children.length; ++i) {
            let { top } = leftRef.current.children[i].getBoundingClientRect();
            if (top - offsetTop >= 0) {
                setActiveIndex(i);
                break;
            }
        }
    }, 50);

    const handleProceed = () => {
        const { nominees = [], bank = [], nomineeFlag, ...investerDetails } = purchaseDetails;

        const parsedNomineeDetails = nominees.map((nominee: any) => {
            const thisYear = new Date().getFullYear();
            const nomineeDobYear = new Date(nominee.dob).getFullYear();
            return {
                ...nominee,
                nomineeGuardian: !!nominee.nomineeGuardian
                    ? nominee.nomineeGuardian
                    : nominee.guardian,
            };
        });

        dispatch({
            type: UPDATE_PURCHASE_INFO,
            body: { nominees: parsedNomineeDetails },
        });
        const payload: any = {
            investorDetails: {
                nominee: parsedNomineeDetails,
                bank: bank[0],
                nomineeFlag,
                ...investerDetails,
            },
        };
        const extraOptions = {
            chequeFile: props.chequeFile,
            pennyDropStatus: props.pennyDropStatus,
        };

        let validate: ValidationErrorRes = { error: false };
        const isError = NewPurchaseValidations.slice(2, NewPurchaseValidations.length).some(
            (func) => {
                validate = func.apply({}, [payload, extraOptions]);
                return validate.error;
            },
        );
        if (isError) {
            setErrorSecton(validate);
            if (validate?.section !== undefined) _handleLeftPane(validate?.section); // Scroll to error
            return;
        }
        setIsProceed(true);
    };

    useEffect(() => {
        async function getCountries() {
            try {
                const { body } = await props.getCountries();
                const { countries: masterData = [] }: any = body;
                setCountries(masterData);
            } catch (err: any) {
                alert(err.message);
            }
        }
        getCountries();
    }, []);

    useEffect(() => {
        setPurchaseDetailsInfo(purchaseDetails);
    }, [purchaseDetails]);

    const onGoBack = () => {
        props.history.goBack();
    };

    useEffect(() => {
        if (props.history.action === 'PUSH') {
            setErrorSecton(props.location.state?.section || null);
        }
        return () => {
            dispatch({ type: CLEAR_SIP_OR_LUMPSUM });
        };
    }, []);

    useEffect(() => {
        if (isProceed) {
            props.history.goBack(); // [#Fix me]
        }
        return () => {
            if (props.history.action === 'POP' && !isProceed) {
                resetData();
            }
        };
    }, [props.history, isProceed]); // reset data to initial state while go backing

    // if(!purchaseDetails.investorName) return null;

    const resetErrorSection = useCallback(
        (section: ErrorSectionTypes) => {
            if (errorSection !== null && section === errorSection?.section) {
                setErrorSecton(null);
            }
        },
        [errorSection],
    );

    return (
        <div className="curved-bg faq-curved commercial-trans new-purchase profile-edit-screen">
            <h2 className="heading">
                <a onClick={onGoBack}>
                    <img src="/images/left-arrow-black.svg" alt="" />
                </a>
                {dbCommercial.newPurchase.leftMenu.editProfileDetails}
            </h2>
            <div className="curved-bg-content">
                <div className="faq-content-outer">
                    <div className="faq-content-left">
                        <div className="faq-content-left-list">
                            <a
                                onClick={() => _handleLeftPane(0)}
                                className={activeIndex === 0 ? 'active' : ''}
                            >
                                <img
                                    className="inactive"
                                    src="/images/profile-personal-grey.svg"
                                    alt=""
                                />
                                <img
                                    className="active"
                                    src="/images/profile-personal-color.svg"
                                    alt=""
                                />
                                {dbCommercial.newPurchase.leftMenu.personalDetails}
                            </a>
                            <a
                                onClick={() => _handleLeftPane(1)}
                                className={activeIndex === 1 ? 'active' : ''}
                            >
                                <img
                                    className="inactive"
                                    src="/images/profile-nominee-grey.svg"
                                    alt=""
                                />
                                <img
                                    className="active"
                                    src="/images/profile-nominee-color.svg"
                                    alt=""
                                />
                                {dbCommercial.newPurchase.leftMenu.nomineeDetails}
                            </a>
                            <a
                                onClick={() => _handleLeftPane(2)}
                                className={activeIndex === 2 ? 'active' : ''}
                            >
                                <img
                                    className="inactive"
                                    src="/images/profile-fatca-grey.svg"
                                    alt=""
                                />
                                <img
                                    className="active"
                                    src="/images/profile-fatca-color.svg"
                                    alt=""
                                />
                                {dbCommercial.newPurchase.leftMenu.fatcaKyc}
                            </a>
                            <a
                                onClick={() => _handleLeftPane(3)}
                                className={activeIndex === 3 ? 'active' : ''}
                            >
                                <img
                                    className="inactive"
                                    src="/images/profile-bank-grey.svg"
                                    alt=""
                                />
                                <img
                                    className="active"
                                    src="/images/profile-bank-color.svg"
                                    alt=""
                                />
                                {dbCommercial.newPurchase.leftMenu.bankDetails}
                            </a>
                        </div>
                    </div>
                    <div
                        className="faq-content-right"
                        onScroll={(e: any) => _handleRightScroll(leftScrollRef)}
                    >
                        <div className="faq-content-right-content">
                            {!!purchaseDetailsInfo && countryData ? (
                                <>
                                    <div className="new-purchase-right" ref={leftScrollRef}>
                                        <PersonalDetailsPurchase
                                            apiData={purchaseDetailsInfo}
                                            isin={props.match.params.isin}
                                            errorSection={
                                                errorSection?.section ===
                                                ErrorSectionTypes.PersonalDetails
                                                    ? errorSection
                                                    : null
                                            }
                                            resetError={() =>
                                                resetErrorSection(ErrorSectionTypes.PersonalDetails)
                                            }
                                        />
                                        <NomineeDetailsPurchase
                                            apiData={purchaseDetailsInfo}
                                            isin={props.match.params.isin}
                                            errorSection={
                                                errorSection?.section ===
                                                ErrorSectionTypes.NomineeDetails
                                                    ? errorSection
                                                    : null
                                            }
                                            resetError={() =>
                                                resetErrorSection(ErrorSectionTypes.NomineeDetails)
                                            }
                                            kfinFlag={props.location.state.kfinFlag}
                                        />
                                        <FatcaDetailsPurchase
                                            apiData={purchaseDetailsInfo}
                                            countryData={countryData}
                                            isin={props.match.params.isin}
                                            errorSection={errorSection}
                                            resetError={() =>
                                                resetErrorSection(ErrorSectionTypes.KycDetails)
                                            }
                                        />
                                        <BankDetailsPurchase
                                            kfinFlag={props.location.state.kfinFlag}
                                            isin={props.match.params.isin}
                                            apiData={purchaseDetailsInfo}
                                            errorSection={
                                                errorSection?.section ===
                                                ErrorSectionTypes.BankDetails
                                                    ? errorSection
                                                    : null
                                            }
                                        />
                                    </div>
                                    <div className="new-purchase-right">
                                        <div className="mobile-fixed-button">
                                            <div className="btns">
                                                <Button
                                                    className="customBtn"
                                                    onClick={handleProceed}
                                                >
                                                    {dbCommercial.newPurchase.rightMenu.proceed}
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <LoadDots />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default connect(
    ({ authReducer, newPurchase }: RootStateType) => ({ ...authReducer, ...newPurchase }),
    {
        getCountries,
    },
)((props: any) => LoadProfileRoutes(props, ProfileDetails));

export function LoadProfileRoutes(props: any, Component: React.FunctionComponent) {
    const { purchaseDetails }: any = useSelector(({ newPurchase }: RootStateType) => ({
        ...newPurchase,
    }));
    const history = useHistory();
    const { isin } = props.match.params || {};
    if (purchaseDetails.defaultInit) {
        history.replace(`${CommercialRootPath}/${isin}/invest`);
        return null;
    }
    return <Component {...props} apiData={purchaseDetails} />;
}
